export const useButtonStylesFromProps = ({ primary, secondary, tertiary, textLink, warning }) =>
  (primary ? 'button--primary ' : '') +
    (secondary ? 'button--secondary ' : '') +
    (tertiary ? 'button--tertiary ' : '') +
    (warning ? 'button--warning ' : '') +
    (textLink ? 'text-link' : '')

export const constructClassNamesAndChildProps = ({ className, fullWidth, type, textLink }, style) =>
  `${className || (textLink ? '' :'button' )} ${style || ''}${fullWidth ? 'full-width ' : ''}`
